import React from 'react';
import { Sprite } from '@agissc/ktag-map';
import { useTranslation } from 'react-i18next';

const WmtsLegend = () => {
  const { t } = useTranslation('agisviewer');

  return (
    <div className="legend__extern-link">
      <Sprite id="i-circle" additionalClassNames="legend__icon" />
      <span>{t('no_legend_wmts')}</span>
    </div>
  );
};

export default WmtsLegend;
